import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import './Layout.css';
import NavBar from './NavBar';
import ToolbarTop from './ToolbarTop';
import Breadcrumbs from './Breadcrumbs';
import BackToTop from '../common/BackToTop';
import HelpWidget from '../common/HelpWidget';
import NotificationBar from '../notifications/NotificationBar';
import Footer from './Footer'; // Importação do componente Footer

function Layout({ children }) {
  const location = useLocation();

  return (
    <div className="app-layout" data-testid="app-layout">
      <NotificationBar data-testid="notification-bar" />
      <ToolbarTop data-testid="toolbar-top" />
      <header className="app-header" data-testid="app-header">
        <NavBar data-testid="nav-bar" />
      </header>
      {location.pathname !== '/' && <Breadcrumbs data-testid="breadcrumbs" />}
      <main className="app-content" data-testid="app-content">
        {children}
      </main>
      <Footer data-testid="footer" /> {/* Uso do componente Footer */}
      <HelpWidget data-testid="help-widget" />
      <BackToTop data-testid="back-to-top" />
    </div>
  );
}

// Validação de prop-types
Layout.propTypes = {
  children: PropTypes.node.isRequired, // 'children' é obrigatório e do tipo 'node'
};

export default Layout;
